const defaultState = {
  gtm: undefined,
};

export default (state = defaultState) => state;
